import { Box, Typography, Button, useTheme } from '@mui/material';
import LayoutModal from '../LayoutModal';
import BaseButton from '../common/BaseButton';
import { useTranslation } from 'react-i18next';

const CreditsBalanceModal = ({ open = false, handleClose, onBuyMore }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <LayoutModal open={open} handleClose={handleClose} disabledIcon={true}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 0 }}>
        <img 
          src="/static/img/no-credits-icon.svg" 
          alt="Out of credit"
          style={{ width: '72px', height: '72px', marginBottom: '24px' }}
        />

        {/* Title */}
        <Typography 
          sx={{ 
            fontWeight: 500, 
            fontSize: '24px',
            color: isDarkMode ? '#fff' : '#1A1D1F',
            mb: 2 
          }} 
          component="h2"
        >
          {t('credits_balance.out_of_credit', 'Your credits have run out')}
        </Typography>

        {/* Description */}
        <Typography 
          sx={{ 
            color: isDarkMode ? '#9A9FA5' : '#6F767E',
            fontSize: '15px',
            lineHeight: 1.5,
            mb: 6,
            maxWidth: '380px'
          }}
        >
          {t('credits_balance.out_of_credit_desc', "You’ve used all credits included in your current plan. To continue using services, purchase additional credits.")}
        </Typography>

        {/* Buy More Credits Button */}
        <BaseButton
          onClick={onBuyMore}
          sx={{ 
            width: '100%', 
            mb: 3,
            height: '48px',
            borderRadius: '12px'
          }}
        >
          {t('button_text.buy_more_credits', 'Buy More Credits')}
        </BaseButton>

        {/* Maybe Later Button (acts as close) */}
        <Button 
          variant="text" 
          onClick={handleClose}
          disableRipple
          sx={{ 
            color: isDarkMode ? '#9A9FA5' : '#6F767E',
            textTransform: 'none',
            fontSize: '15px',
            fontWeight: 500,
            '&:hover': {
              bgcolor: 'transparent',
              color: isDarkMode ? '#fff' : '#1A1D1F'
            }
          }}
        >
          {t('button_text.maybe_later', 'Maybe later')}
        </Button>
      </Box>
    </LayoutModal>
  );
};

export default CreditsBalanceModal;
